import * as angular from 'angular';

import { ChartIdentifierWidgetConfiguration, WidgetWithErrors, OrderBy } from '../';
import { IwidgetIntervalHelperService } from '../../services';
import { Helper } from '../../common/';
import { WidgetValuesReadConfiguration, ReadType, IBindable } from '../../models/';
import { doughnutChartWidgetDefinition as definition } from '../../widgets/widgets.definition.index';

export class DoughnutChartWidget extends WidgetWithErrors {
    baseType = definition.baseType;
    col = 0;
    configuration: ChartIdentifierWidgetConfiguration;
    exportToCsv: () => angular.IPromise<any>;
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    isExportable = true;
    isMaximizable = true;
    isMaximized = false;
    name = definition.title;
    row = 0;
    sizeX = 4;
    sizeY = 18;
    type = definition.type;

    constructor($translate: angular.translate.ITranslateService,
        private _$q: angular.IQService,
        intervalHelper: IwidgetIntervalHelperService) {
        super(intervalHelper);
        this.guid = Helper.getGuid();
        this.configuration = new ChartIdentifierWidgetConfiguration($translate);
        this.configuration.options.coloringMode = 1;
        this.configuration.options.title = 'Title';
        this.configuration.options.isLegendVisible = true;
        this.configuration.isEndDateIncluded = false;
        this.configuration.options.thickness = 20;
        this.configuration.nameConfiguration.hasUnit = true;
        this.configuration.options.orderBy = OrderBy.LargestToSmallest;
    }

    getReadConfiguration(beginDate: string, endDate: string): WidgetValuesReadConfiguration {
        return this.getReadConfigurationBase(beginDate, endDate, this.configuration.series, this.configuration,
            this.configuration.aggregation,
            false, false, false, false, false, ReadType.AggregatedValue, false,
            this.configuration.options.variableTypeGuid,
            this.configuration.options.unitGuid);
    }

    getReadConfigurationAsync(): angular.IPromise<WidgetValuesReadConfiguration> {
        return this.getSeriesListAsync()
            .then(data => {
                const hasQuality = false;
                const hasMissingRanges = false;
                const hasContext = false;
                const hasTendency = false;
                const hasTarget = false;
                const aggregation = this.configuration.aggregation;
                const widgetValuesReadConfiguration = this.createConfiguration(data, aggregation, hasQuality,
                    hasMissingRanges, hasContext,
                    hasTendency, hasTarget, ReadType.AggregatedValue,
                    this.configuration.options.variableTypeGuid,
                    this.configuration.options.unitGuid);

                return widgetValuesReadConfiguration;
            });
    }

    private getSeriesListAsync(): angular.IPromise<IBindable[]> {
        const result = this.configuration.series.map(d => {
            return {
                guid: d.guid,
                originalGuid: d.guid,
                value: d.value,
                relativePath: d.relativePath,
                isBoundToGroup: d.isBoundToGroup
            };
        });
        return this._$q.when(result);
    }
}